<div class="vendor-create">
  <div class="vendor-create__content">
    <div class="vendor-create__layout">
      <div class="vendor-create__header">
        <div class="vendor-create__heading">
          <h1 class="page-title">Create Vendor</h1>
          <p class="page-subtitle">Register a vendor for printing or shipment operations.</p>
        </div>
        <div class="vendor-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || form.invalid" (click)="save()">
            {{ isSaving ? "Creating..." : "Create vendor" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="form" class="vendor-create__form">
          <div class="vendor-create__form-grid">
            <div class="vendor-create__form-field">
              <label for="name" class="vendor-create__form-label">Vendor Name</label>
              <input
                id="name"
                type="text"
                formControlName="name"
                class="vendor-create__form-input"
                [class.vendor-create__form-input--error]="form.get('name')?.invalid && form.get('name')?.touched" />
              @if (form.get('name')?.invalid && form.get('name')?.touched) {
              <div class="vendor-create__form-error">Vendor name is required.</div>
              }
            </div>

            <div class="vendor-create__form-field">
              <label for="vendor-pages-create-vendorcreatepage-field-1" class="vendor-create__form-label">Type</label>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="typeOptions"
                placeholder="Search type..."
                [minLength]="1"
                [debounceMs]="200"
                (selectionChange)="onTypeChange($event)"></app-autocomplete>
              @if (form.get('type')?.invalid && form.get('type')?.touched) {
              <div class="vendor-create__form-error">Vendor type is required.</div>
              }
            </div>
          </div>

          <div class="vendor-create__form-grid">
            <div class="vendor-create__form-field">
              <label for="contactPerson" class="vendor-create__form-label">Contact Person</label>
              <input id="contactPerson" type="text" formControlName="contactPerson" class="vendor-create__form-input" />
            </div>

            <div class="vendor-create__form-field">
              <label for="phone" class="vendor-create__form-label">Phone</label>
              <input id="phone" type="text" formControlName="phone" class="vendor-create__form-input" />
            </div>
          </div>

          <div class="vendor-create__form-grid">
            <div class="vendor-create__form-field">
              <label for="email" class="vendor-create__form-label">Email</label>
              <input id="email" type="email" formControlName="email" class="vendor-create__form-input" />
            </div>
          </div>

          <div class="vendor-create__form-field">
            <label for="vendor-pages-create-vendorcreatepage-field-2" class="vendor-create__form-label">Note</label>
            <app-rich-text-editor formControlName="note" placeholder="Write vendor notes..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>

      <app-card class="vendor-create__address-card">
        <div class="vendor-create__section-header">
          <div>
            <h2 class="vendor-create__section-title">Address Information</h2>
            <p class="vendor-create__section-hint">Select administrative area and line details for this vendor.</p>
          </div>
        </div>

        <app-location-selector (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
